export const TEST_IDS = {
  SEARCH_PAGE_BREADCRUMBS: 'search-page-breadcrumbs'
};